import { render, staticRenderFns } from "./CompraPorPeriodo.vue?vue&type=template&id=10643524&scoped=true&"
import script from "./CompraPorPeriodo.vue?vue&type=script&lang=js&"
export * from "./CompraPorPeriodo.vue?vue&type=script&lang=js&"
import style0 from "./CompraPorPeriodo.vue?vue&type=style&index=0&id=10643524&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../Users/lucianocolucci/Desktop/Share Windows/IngeniAR/WebProject/Syscore-mods/Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10643524",
  null
  
)

export default component.exports